var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: { width: "12", height: "14", xmlns: "http://www.w3.org/2000/svg" }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M1.72223177 11.8142769h8.55553643V4.89998674H1.72223177v6.91429016zM10.2777682 1.7571517h-.6111015V.5H8.4444349v1.2571517H3.5555651V.5H2.33333333v1.2571517h-.61110156c-.67529687 0-1.21613021.56256116-1.21613021 1.25712223L.5 11.8142769c0 .694561.5469349 1.2571517 1.22223177 1.2571517h8.55553643c.6752969 0 1.2222318-.5625907 1.2222318-1.2571517V3.01427393c0-.69456107-.5469349-1.25712223-1.2222318-1.25712223z",
          fill: _vm.color,
          "fill-rule": "evenodd",
          opacity: ".90000004"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }